import React, { useEffect, createElement } from 'react';
import { ReadingProgress } from './components/ReadingProgress';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BodyContent } from './components/BodyContent';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),
    event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='
    +i+dl;f.parentNode.insertBefore(j,f);})(window,document,
    'script','dataLayer','GTM-KZBZMFT');`;
    document.head.appendChild(script);
  }, []);
  return <div className="min-h-screen bg-bg font-serif text-text" data-id="element-0">
      <ReadingProgress data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <BodyContent data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}